export const PLAY_STORE_LINK = 'https://play.google.com/store/apps/details?id=me.hushup.android';
export const FACEBOOK_PAGE = 'https://www.facebook.com/Hushup-App-1383492181756379/';
export const TWITTER_PAGE = 'https://twitter.com/_Hush_UP_';
export const INSTA_PAGE = 'https://www.instagram.com/hushupapp/';
